import UserMatchPercentage from "components/match/UserMatchPercentage/UserMatchPercentage";
import Avatar from "hardcover-ui/components/Avatar";
import { AvatarThemeProps } from "hardcover-ui/theme/components/avatar";
import TextLink from "hardcover-ui/components/TextLink";
import Text from "hardcover-ui/components/Text";

export interface Props {
  user: any;
  byline?: boolean | string;
  size?: AvatarThemeProps["size"];
  className?: string;
  match?: boolean;
}

function Byline({ byline }: { byline: boolean | string }) {
  if (!byline) {
    return false;
  }
  const message = typeof byline === "string" ? byline : "By";
  return (
    <Text className="hidden md:inline" variant="secondary">
      {message}
    </Text>
  );
}
export default function UserByline({
  user,
  size = "md",
  byline = false,
  match = false,
  className = "",
}: Props) {
  return (
    <div className={`${className} flex flex-row space-x-1 items-center`}>
      <TextLink href={`/@${user.username}`} variant="normal">
        <Avatar
          image={user.image}
          alt={user.username}
          size={size}
          variant="bordered"
        />
      </TextLink>
      <div className="flex flex-row items-center flex-wrap leading-8 space-x-1">
        <Byline byline={byline} />
        {user.name?.length > 0 && (
          <TextLink
            href={`/@${user.username}`}
            className="font-semibold mr-2"
            size="md"
            variant="normal"
          >
            {user.name}
          </TextLink>
        )}
        {user.flair && user.flair.length > 0 && (
          <span className="bg-yellow-300 text-yellow-800 font-semibold rounded px-1 py-0.5 text-xs mr-2">
            {user.flair}
          </span>
        )}
        {match && <UserMatchPercentage userId={user.id} />}
      </div>
    </div>
  );
}
